import {ScorecardRow} from "./row";
import {AltValue, AltValueType, CourseCard} from "../model/course-card-model";
import {arrayOrEmpty} from "../../../common/extensions/array";


export function getHolesRow(scorecard: CourseCard): ScorecardRow {
    return {
        name: "Hole",
        outValues: scorecard.hole.outValues,
        outTotal: scorecard.hole.outTotal != null ? "Out" : null,
        inValues: arrayOrEmpty(scorecard.hole.inValues),
        inTotal: scorecard.hole.outTotal != null ? "In" : null,
        total: "Total",
        classes: "holes"
    };
}

export function getParsRow(scorecard: CourseCard): ScorecardRow {
    return {
        name: "Par",
        outValues: scorecard.par.outValues.map(formatAltValue),
        outTotal: formatAltValueOrNull(scorecard.par.outTotal),
        inValues: arrayOrEmpty(scorecard.par.inValues).map(formatAltValue),
        inTotal: formatAltValueOrNull(scorecard.par.inTotal),
        total: formatAltValue(scorecard.par.total),
        classes: "pars"
    };
}


export function getHandicapRow(scorecard: CourseCard): ScorecardRow {
    return {
        name: "Hcp",
        outValues: scorecard.strokeIndex.outValues.map(formatAltValue),
        outTotal: formatAltValueOrNull(scorecard.strokeIndex.outTotal),
        inValues: arrayOrEmpty(scorecard.strokeIndex.inValues).map(formatAltValue),
        inTotal: formatAltValueOrNull(scorecard.strokeIndex.inTotal),
        total: formatAltValue(scorecard.strokeIndex.total),
        classes: "handicaps"
    };
}

function formatAltValueOrNull(value: AltValue | null): string | null {
    if (value)
        return formatAltValue(value)
    else
        return null
}

function formatAltValue(value: AltValue): string {
    switch (value.type) {
        case AltValueType.Single:
            return value.value
        case AltValueType.Pair:
            return `<span class="alt-value"><sup>${value.value}</sup>/<sub>${value.altValue}</sub></span>`
        default:
            return ""
    }
}

